<template>
  <v-container class="px-6">
    <h1>Pagamentos em processamento</h1>
    <p>Monitoramento de datas de pagamento por operadora.</p>
    <PagamentosFilter
      :prestadores="prestadores"
      :operadoras="listOperadora"
      :filterList="(formData, page, clear) => getList(formData, 1, clear)"
      :formatDate="(date) => formatDate(date)"
      :parseDate="(date) => parseDate(date)"
      :grupoEconomico="grupoEconomico"
      :getOperadoras="(opts)=>getOperadoras(opts)"
    />
    <PagamentosList
      :list="list"
      :pagination="pagination"
      :filterData="filterData"
      :showOpen="(item) => showOpen(item)"
      :historico="historico"
      :getList="(filter, page) => getList(filter, page)"
      :getDocument="(opts) => getDocument(opts)"
      :grupo_economico="grupoEconomico"
      :totais="totaisProce"
    />
    <!-- <HistoricoEventosDlg
      :dialog="dialog"
      :close="() => close()"
      :historico="historico"
    /> -->
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex"
import PagamentosFilter from './pagamentos_em_process/Filter'
import PagamentosList from './pagamentos_em_process/List'
// import HistoricoEventosDlg from './HistoricoEventosDlg'
export default {
  components: {
    PagamentosFilter,
    PagamentosList,
    // HistoricoEventosDlg
  },
  data() {
    return{
      prestadores: [],
      list: [],
      dialog: false,
      historico: [],
      pagination: {
        offset: 1,
        limit: 20,
        total_pages: 0
      },
      filterData: {},
      totaisProce: {
        valor_liberado: 0,
        valor_glosado: 0
      }
    };
  },
  computed: {
    ...mapState({
      grupoEconomico: (state) => state.permissions.grupoEconomico,
      grupoEconomicoList: (state) => state.permissions.grupoEconomicoList,
      listOperadora: (state) => state.faturamento.listOperadora,
    }),
  },
  watch: {
    grupoEconomicoList: {
      deep: true,
      handler() {
        this.prestadores = this.$store.getters[
          "permissions/getPrestadoresByGeco"
        ]();
      },
    },
  },
  mounted() {
    this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"]()
    let userData = this.$store.state.userData.userData
    this.controlResponsavel = !userData.Permissao.faturamento.includes('gestor')
    let opts = {
      grupoEconomico: this.grupoEconomico,
      prestador_ids: [],
      modulo_operadora: "recebiveis",
      
    }
    this.getOperadoras(opts)
  },
  methods: {
    ...mapActions({
      "getOperadoras":"permissions/getOperadoras",
      "getDocument":"documents/getDocument",
    }),
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null
      const [day, month, year] = date.split('/')
      return `${year}-${month}-${day}`
    },
    showOpen(payload) {
      // this.dialog = true
      let obj = {
        query: [{
          Modulo: "Recebiveis",
          Acao: "gethistoricopagamentos",
          Payload: {
            grupo_economico: this.grupoEconomico,
            prestador_id: payload.prestador_id,
            operadora_ans_id: payload.operadora_ans_id,
            data_pagamento: payload.data_pagamento
          }
        }],
      }
      this.$store.dispatch('request/doRequest', obj).then((response) => {
        if (!response || response.isAxiosError || response.error) {
          this.$store.commit("hideLoader")
          return
        }
        this.historico = response.dados
      })
    },
    close() {
      this.dialog = false
    },
    getList(filter, page, clear) {
      let {order, sort} = filter && filter.sort? filter : this.filterData
      this.filterData = {...this.filterData, ...filter, order, sort}
      if(clear){
        this.pagination.total_pages = 0
        this.pagination.offset = 1
        this.list = []
        return
      }
      this.pagination.offset = page? page : 1
      let payload = { grupo_economico: this.grupoEconomico, ...this.pagination, ...this.filterData }
      let obj = {
        query: [{
          Modulo: "Recebiveis",
          Acao: "getpagamentosprocessamento",
          Payload: payload,
        }],
      }
      this.$store.dispatch('request/doRequest', obj).then((response) => {
        if (!response || response.isAxiosError || response.error) {
          this.$store.commit("hideLoader")
          return
        }
        let { dados, total_pages, current_page, valor_liberado, valor_glosado } = response
        this.pagination.total_pages = total_pages
        this.pagination.offset = current_page
        this.list = dados
        this.totaisProce.valor_liberado = valor_liberado
        this.totaisProce.valor_glosado = valor_glosado
        })
    },
  }
}
</script>

<style>

</style>